import useTheme from "@/hooks/useTheme";
import { Outlet } from "react-router-dom";

export default function Root() {
  useTheme();
  return (
    <div className="root">
      <Outlet />
    </div>
  );
}
